import { UtcDate } from '@/helpers/date';

export default {
  computesRequired: true,
  params: ['field'],
  validate: (value, { field }) => {
    const result = {
      valid: true,
    };

    if (field === null) return result;

    const updatedValue = value.includes(' (today)') ? value.split(' ')[0] : value;
    // Change format back to YYYY-MM-DD so it can be parsed
    const formatted = updatedValue.split('-').reverse().join('-');
    const updatedFieldValue = field.includes(' (today)') ? field.split(' ')[0] : field;

    const date = new UtcDate(formatted);

    result.valid = date.isAfterOrEqual(updatedFieldValue);

    return result;
  },
};
